import { Controller } from "@hotwired/stimulus";
import Masonry from "masonry-layout";

// Connects to data-controller="masonry"
export default class extends Controller {
  connect() {
    this.setup();
  }

  setup() {
    if (this.masonry) return;

    this.masonry = new Masonry(this.element, {
      percentPosition: true,
    });
  }


  reload() {
    this.masonry.layout();
  }
}
